import { HandleSongsCategoryList, TopPlaylistResponse } from '@/types/songs-api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface InitialState {
    category: HandleSongsCategoryList[]
    currentCategory: string
    categorySongs: TopPlaylistResponse
}

const initialState: InitialState = {
    category: [],
    currentCategory: '全部',
    categorySongs: {} as TopPlaylistResponse,
}

const songsSlice = createSlice({
    name: 'songs',
    initialState,
    reducers: {
        changeCategory(state, action: PayloadAction<HandleSongsCategoryList[]>) {
            state.category = action.payload
        },
        changeCurrentCategory(state, action: PayloadAction<string>) {
            state.currentCategory = action.payload
        },
        changeCategorySongs(state, action: PayloadAction<TopPlaylistResponse>) {
            state.categorySongs = action.payload
        },
    },
})

export const { changeCategory, changeCurrentCategory, changeCategorySongs } = songsSlice.actions
export default songsSlice.reducer
